import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Funnel, Sparkles } from 'lucide-react';
import SearchBar from "components/search/SearchBar";
import SelectOption from "components/select/SelectOption";
import JobListPanel from "./JobListPanel";
import { 
        getCareersJobPostList,
 } from "../../../../redux/employeereferral/employeeReferralState";

const JobPostList = () => {

  const dispatch = useDispatch();
  
  const recordList = useSelector((state) => state.employeeReferral.careersJobPostList.items);
  const filters = useSelector((state) => state.employeeReferral.careersJobPostList.filters);

  useEffect(() => {
      dispatch(getCareersJobPostList(filters));
  }, [dispatch]);

  return (
    <div className="careers mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="relative gradient-effect ">
        <div className="group-hover:opacity-30 transition-opacity" />
        <div className="card-shadow"/>
        <div className="card-border-effect space-y-2">
          <div className="inline-flex gap-3 grid grid-cols-4">
            <SearchBar
              placeholder="Search jobs..."
            />
            <SelectOption
              placeholder="All Departments"
            />
            <SelectOption
              placeholder="All Locations"
            />
            <SelectOption
              placeholder="All Types"
            />
          </div>

          <div className="flex items-center gap-1">
            <Sparkles className="w-4 h-4 text-purple-600" />
            <span className="flex gap-1">
              Showing
				    <p className="font-semibold text-purple-600">{recordList?.length}</p>
              positions
            </span>
          </div>
        </div>
      </div>
        <JobListPanel 
          jobs={recordList}
        />
    </div>
  );
};


export default JobPostList;
